class TaskType {

    static TROUBLETICKET = 'TROUBLETICKET'
    static PROJECTTASK = 'PROJECTTASK'
    static ALL = 'ALL'

}

export default TaskType